// extracted by mini-css-extract-plugin
module.exports = {"PostMenuTrigger":"mq_a bag_i bag_j bag_q bag_sr bag_uh bag_en"};